import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'internal-error.title',
    defaultMessage: 'We’ll be back soon',
  },
  body: {
    id: 'internal-error.body',
    defaultMessage:
      'Please try refreshing your page and if the problem persists contact <a>Partner Success</a> and we’ll get to the bottom of it.',
  },
});
